import {
  RECEIVE_MONTH_DATA,
  BLOCK_DATE_SELECTION,
  SET_FLIGHT_VIEW_MODE,
  DISMISS_NO_DIRECTS_MESSAGE,
} from '../helpers/constants/actionsConstants';
import {
  CALENDAR_VIEW_MODE,
  VALID_VIEW_MODES,
} from '../helpers/constants/dataTypeConstants';

import type { ReceiveMonthDataStartAction, UIAction } from '../actions/types';
import type { UIState } from '../selectors/types';

type Action = UIAction | ReceiveMonthDataStartAction;

const initialState: UIState = {
  selectedViewMode: CALENDAR_VIEW_MODE,
  allowUserDateSelection: true,
  noDirectsMessageDismissed: false,
};

const isValidViewMode = (mode: string): mode is UIState['selectedViewMode'] =>
  (VALID_VIEW_MODES as ReadonlyArray<UIState['selectedViewMode']>).includes(
    mode as UIState['selectedViewMode'],
  );

const reducer = (state: UIState = initialState, action: Action): UIState => {
  switch (action.type) {
    case SET_FLIGHT_VIEW_MODE:
      return isValidViewMode(action.payload.mode)
        ? { ...state, selectedViewMode: action.payload.mode }
        : state;

    case `${RECEIVE_MONTH_DATA}_STARTED`:
      return { ...state, allowUserDateSelection: true };

    case BLOCK_DATE_SELECTION:
      return { ...state, allowUserDateSelection: false };

    case DISMISS_NO_DIRECTS_MESSAGE:
      return { ...state, noDirectsMessageDismissed: true };

    default:
      return state;
  }
};

export default reducer;
